export enum JobStatus {
    Stopped,
    Started,
    Calculating,
    Failed
}